import { put , call, takeEvery} from 'redux-saga/effects';
import {setApprovalList , setApiStatus} from '../actions/ApprovalListActions';
import * as appConstants from '../constants/AppConstants';
import _ from 'lodash';
import ApprovalService from "../services/ApprovalService";


export function* approvalListSaga(){

    yield takeEvery('GET_APPROVAL_LIST', function* (action){
        const { flowId } = action;
        yield call(approvalListActionSaga,flowId);
    })  
}

export function* approvalListActionSaga(flowId){
    let list = [];
    yield put(setApprovalList(list));
    yield put(setApiStatus(true));
    try{
        const response = yield call(ApprovalService.getApprovalList,flowId);
        if (response.data) {            
            let selectedTabApprovals = response.data;
            let pendingArray = _.filter(selectedTabApprovals, function (obj) {
                return obj.status === appConstants.PENDING
            });
            let nonPendingArray = _.filter(selectedTabApprovals, function (obj) {
                return obj.status !== appConstants.PENDING
            });
            let approvalList = [...pendingArray, ...nonPendingArray];
            //set approval List
            
            yield put(setApprovalList(approvalList));
            yield put(setApiStatus(false));
        }
    }catch(error){
        yield put(setApiStatus(false));
        yield put(setApprovalList([]));
    }
    
}

